"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stdMarkerTypes = exports.parseGooglePlace = exports.getTimezone = exports.getPlaceName = exports.getPlaceLatLong = exports.getGeoMapConstants = exports.getAddressString = exports.clusterStyles = exports.addControls = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _CustomControl = _interopRequireDefault(require("./CustomControl"));
var _CallingCodes = _interopRequireDefault(require("../common/data/CallingCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const locationApiKey = window['CLEO_CONFIG'] && window['CLEO_CONFIG']['locationApiKey'];
const geocodeService = window['CLEO_CONFIG'] && window['CLEO_CONFIG']['geocodeService'];
const timeZoneService = window['CLEO_CONFIG'] && window['CLEO_CONFIG']['timeZoneService'];
// @TODO Should come from some sort of config down the line.
const getGeoMapConstants = () => ({
  defaultCenter: {
    lat: 37.406691,
    lng: -121.976936
  },
  defaultZoom: 15
});

/**
 * @TODO document it.
 * @param {*} place place from google maps.
 */
exports.getGeoMapConstants = getGeoMapConstants;
const parseGooglePlace = place => {
  const parcedPlace = {
    name: place.name,
    street1: '',
    state: '',
    city: '',
    formattedAddress: place.formatted_address
  };
  if (typeof place.geometry.location.lat === 'function') {
    parcedPlace.latitude = place.geometry.location.lat();
    parcedPlace.longitude = place.geometry.location.lng();
  } else {
    parcedPlace.latitude = place.geometry.location.lat;
    parcedPlace.longitude = place.geometry.location.lng;
  }
  place.address_components.forEach(add => {
    if (add.types.includes('postal_code')) {
      parcedPlace.zip = add.long_name;
    } else if (add.types.includes('sublocality')) {
      parcedPlace.street1 = parcedPlace.street1.length > 0 ? `${parcedPlace.street1}, ${add.long_name}` : add.long_name;
    } else if (add.types.includes('street_number')) {
      parcedPlace.street1 = `${parcedPlace.street1} ${add.long_name}`;
    } else if (add.types.includes('route')) {
      parcedPlace.street1 = `${parcedPlace.street1} ${add.long_name}`;
    } else if (add.types.includes('locality')) {
      parcedPlace.city = add.long_name;
    } else if (add.types.includes('administrative_area_level_1')) {
      parcedPlace.state = add.long_name;
    } else if (add.types.includes('country')) {
      const country = _CallingCodes.default.find(cc => cc.code === add.short_name);
      if (!country || !country.isoCode) {
        parcedPlace.country = add.short_name;
      } else {
        parcedPlace.country = country.isoCode;
      }
    }
  });
  if (!parcedPlace.zip) {
    parcedPlace.zip = 0;
  }
  return parcedPlace;
};

/**
 * @todo Srini let document it.
 * @param {*} address
 */
exports.parseGooglePlace = parseGooglePlace;
const getAddressString = address => {
  const {
    name,
    street1,
    city,
    state,
    zip,
    formattedAddress
  } = address;
  if (!address || Object.keys(address).length === 0) {
    return null;
  } else if (formattedAddress) {
    return formattedAddress;
  } else {
    return `${name ? `${name}, ` : ''}${street1 && name !== street1 ? `${street1}, ` : ''}${city ? `${city}, ` : ''}${state ? `${state}, ` : ''}${zip && zip !== '0' ? zip : ''}`;
  }
};
exports.getAddressString = getAddressString;
const getPlaceName = async (lat, lng) => {
  const resp = await fetch(`${geocodeService}?latlng=${lat},${lng}&key=${locationApiKey}`);
  const rr = await resp.json();
  return rr.results[0];
};
exports.getPlaceName = getPlaceName;
const getTimezone = async (lat, lng) => {
  const resp = await fetch(`${timeZoneService}?location=${lat},${lng}&key=${locationApiKey}&timestamp=${Math.floor(Date.now() / 1000)}`);
  const rr = await resp.json();
  return rr;
};
exports.getTimezone = getTimezone;
const getPlaceLatLong = async address => {
  const resp = await fetch(`${geocodeService}?address=${address}&key=${locationApiKey}`);
  const rr = await resp.json();
  return rr.results[0];
};
exports.getPlaceLatLong = getPlaceLatLong;
const stdMarkerTypes = {
  circle: {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 10
  },
  donut: {
    icon: 'http://maps.google.com/mapfiles/kml/shapes/donut.png'
  }
};
exports.stdMarkerTypes = stdMarkerTypes;
const getGoogleClusterInlineSvg = color => {
  const encoded = window.btoa(`<svg 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink" 
        viewBox="0 0 200 200"
      >
        <defs>
          <filter
            id="dropshadow"
            x="0"
            y="0"
            width="110%"
            height="110%"
          >
            <feOffset result="offOut" in="SourceAlpha" dx="2" dy="3" />
            <feGaussianBlur
              result="blurOut"
              in="offOut"
              stdDeviation="2"
            />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
        </defs>
        <g>
          <circle r="90" cy="100" cx="100" fill="#fff" style="filter: url(#dropshadow)"/>
          <circle
            r="60"  
            cy="100" 
            cx="100"  
            stroke-width="28" 
            stroke="${color}" 
            fill="#fff"
          />
        </g>
      </svg>`);
  return `data:image/svg+xml;base64,${encoded}`;
};
const clusterStyles = [{
  width: 50,
  height: 50,
  url: getGoogleClusterInlineSvg('#e0e4ed'),
  textColor: 'black',
  textSize: 14,
  anchorText: [16, 0]
}, {
  width: 50,
  height: 50,
  url: getGoogleClusterInlineSvg('#007f00'),
  textColor: 'black',
  textSize: 14,
  anchorText: [16, 0]
}, {
  width: 50,
  height: 50,
  url: getGoogleClusterInlineSvg('#ff0000'),
  textColor: 'black',
  textSize: 14,
  anchorText: [16, 0]
}];
exports.clusterStyles = clusterStyles;
const addControls = (currMap, controlPosition) => {
  const controlButtonDiv = document.createElement('div');
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_CustomControl.default, {
    map: currMap
  }), controlButtonDiv);
  currMap.controls[controlPosition].push(controlButtonDiv);
};
exports.addControls = addControls;